import React from "react";
import ReactModal from "react-modal";
import moment from "moment";

// import { useFormContext } from "react-hook-form";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#FFEBEA",
    padding: "4em",
  },
};

const BookSlotAlert = ({ modalData, modalFunc,submitBooking,getUserQuery }) => {
//   const { register, setValue, formState } = useFormContext();
//   const { errors } = formState;
console.log("modalData alert ", modalData);
  return (
    <div>
      <ReactModal
        isOpen={modalData?.[1]}
        // onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Slot Booking Modal"
        ariaHideApp={false} ///  shows error if ariaHideApp is not define as false
      >
        {/* <button
          className="btn-sm  btn-blue rounded-5 mb-10"
          onClick={() => closeModal(false)}
        >
          Close
        </button> */}
        <h3 className="text-navyBlue">Slot Booking Information</h3>
        <div className="mt-10 mb-20 ">

        <p ><strong >Expert Name:</strong>  {modalData?.[4]?.expertName} </p>
        <p><strong>Shift: </strong>{modalData?.[5]} </p>
        <p><strong>Slot Date:</strong>   {moment(modalData?.[2]?.slotDate).format("Do MMMM  YYYY")}       </p>
        <p><strong>Slot Time:</strong> {modalData?.[3]?.time} </p>
        <p><strong>User Query:</strong> {getUserQuery} </p>
        <p><strong>Mode:</strong> {modalData?.[7]} </p>
          {
          modalData?.[7] === "offline" && (
            <p><strong>Location Name:</strong> {modalData?.[8]?.split("~")?.[1]} </p>
          )}  

        </div>
        

        <div className="mt-10 btn-wrapper">
          <button
            className="btn-sm  btn-secondary rounded-5"
            type="submit"
            onClick={() => {
                submitBooking(modalData);
            }}
          >
            Confirm
          </button>
          <button
            className="btn-sm  btn-navy-blue rounded-5"
            onClick={() => modalFunc(false,false)}
          >
            Cancel
          </button>
        </div>
      </ReactModal>
    </div>
  );
};

export default BookSlotAlert;
